import { useParams, useNavigate } from "react-router-dom";
import { db, auth } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import TopBar2 from "../../components/common/TopBar2";
import { useTranslation } from "react-i18next";
import { ENABLE_REAL_MONEY_PAYOUTS } from "../../config/featureFlags";

export default function WithdrawConfirmPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [req, setReq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    const load = async () => {
      // Phase PLAY-COMPLIANCE-PAYOUTS-DISABLE: must never read a
      // withdrawal document while real-money payouts are disabled -
      // historical cash-payout details (amount, method, status) must not
      // be fetched into the client at all, direct route access included.
      // Existing Firestore documents are left untouched for future
      // reactivation.
      if (!ENABLE_REAL_MONEY_PAYOUTS) {
        if (alive) setLoading(false);
        return;
      }

      try {
        const ref = doc(db, "withdrawals", id);
        const snap = await getDoc(ref);

        if (!alive) return;

        if (!snap.exists()) {
          navigate("/withdraw-history");
          return;
        }

        const data = snap.data();

        // ✅ حماية
        if (data.uid !== auth.currentUser.uid) {
          navigate("/withdraw-history");
          return;
        }

        setReq({ id: snap.id, ...data });
      } catch (e) {
        console.error(e);
        if (alive) navigate("/withdraw-history");
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();

    return () => {
      alive = false;
    };
  }, [id, navigate]);

  if (loading)
    return (
      <div className="page-loading">
        {t("withdrawConfirm.loading", { defaultValue: "جارٍ التحميل..." })}
      </div>
    );

  // Phase PLAY-COMPLIANCE-PAYOUTS-DISABLE: while real-money payouts are
  // disabled, render a neutral unavailable notice only - no USD amount,
  // payout method, or cash-payout status. The original detail card below
  // is preserved unchanged (not deleted) for reactivation later.
  if (!ENABLE_REAL_MONEY_PAYOUTS) {
    return (
      <div className="withdraw-confirm-page">
        <TopBar2
          title={t("withdrawConfirm.title", { defaultValue: "تفاصيل السحب" })}
          onBack={() => navigate(-1)}
        />

        <div className="withdraw-confirm-content">
          <div className="withdraw-confirm-card">
            <p>
              {t("withdraw.help.payoutsDisabledNotice", {
                defaultValue:
                  "Cash withdrawals are currently unavailable. Tokens are virtual and cannot be redeemed for cash.",
              })}
            </p>
          </div>

          <button
            className="primary-btn"
            onClick={() => navigate("/withdraw-history")}
          >
            {t("common.back", { defaultValue: "رجوع" })}
          </button>
        </div>
      </div>
    );
  }

  if (!req) return null;

  return (
    <div className="withdraw-confirm-page">
      <TopBar2
        title={t("withdrawConfirm.title", { defaultValue: "تفاصيل السحب" })}
        onBack={() => navigate(-1)}
      />

      <div className="withdraw-confirm-content">

        <div className="withdraw-confirm-card">
          <h2>
            {t("withdrawConfirm.detailsTitle", { defaultValue: "تفاصيل الطلب" })}
          </h2>

          <div className="row">
            <span>
              {t("withdrawConfirm.amountLabel", { defaultValue: "المبلغ" })}
            </span>
            <strong>${req.amountUsd}</strong>
          </div>

          <div className="row">
            <span>
              {t("withdrawConfirm.tokensLabel", { defaultValue: "التوكن" })}
            </span>
            <strong>{req.amountTokens}</strong>
          </div>

          <div className="row">
            <span>
              {t("withdrawConfirm.methodLabel", { defaultValue: "الطريقة" })}
            </span>
            <strong>{req.method}</strong>
          </div>

          <div className="row">
            <span>
              {t("withdrawConfirm.statusLabel", { defaultValue: "الحالة" })}
            </span>
            <strong>{req.status}</strong>
          </div>
        </div>

        <button
          className="primary-btn"
          onClick={() => navigate("/withdraw-history")}
        >
          {t("common.back", { defaultValue: "رجوع" })}
        </button>
      </div>
    </div>
  );
}